export default __webpack_public_path__ + "static/media/GuestList.751f27a0.csv";